(function($g, $) {
    "use strict";
    var MIN_TIME_BEFORE_RELOAD = 1000*20;
    var FunctionList = $g.FunctionList;
    var Signal = $g.Signal;
    
    var jobs = new FunctionList();
    var afterSuccess = new Signal();

    var global_is_navigating = false;
    
    function time() {
        return new Date().getTime();
    }
    
    var startedAt = time();

    $(window).on('beforeunload',function() {
        // Note: this event doesn't fire in mobile safari
        global_is_navigating = true;
    });

    function ajax(url, params, sucess, fail) {
        var requestStartedAt = time();
        var token = srv.token;
        var p = $.extend({}, params, {token: token});
        var retry = 0;
        function essai() {
            jobs.exec(function(complete) {
                //TODO: implement timeout
                $.post(url, p).always(function(r, a, b) {
                    try {
                        var gotAnswerAt = time();
                        var requestDelta = gotAnswerAt - requestStartedAt;
                        r=r||{};
                        if (r.succes && complete) {
                            if (sucess) {
                                sucess(r);
                            }
                            afterSuccess.trigger(r);
                        } else {
                            if (global_is_navigating) {
                                return;//ignore errors while navigating away
                            }
                            var retryable = (typeof r.overrideMimeType === "function" && typeof r.succes !== "boolean");
                            token = r.token;
                            if (token) {
                                //got new csrf token ! yes!
                                srv.token = token;
                                p = $.extend({}, params, {token: token}); 
                                retryable = true;
                            }
                            if (retryable && complete) {
                                retry++;
                                //max 2 retry attemp or 15 seconds
                                if (retry>=2 || requestDelta > 15000) {
                                    if (fail) {
                                        fail(r);
                                    } else {
                                        $g.error(r.usermsg||PVPGEngine.networkError, r.msg, r, a, b);
                                    }
                                } else {
                                    essai();
                                }
                            } else {
                                $g.logToSrv(r.usermsg||"erreur réseau", r.msg, r, a, b);
                                var msg = r.usermsg||PVPGEngine.networkError;
                                if (complete) {
                                    if (fail) {
                                        fail(r);
                                    } else {
                                        $g.errorHandler(msg, function() {
                                            if (r.error==="version"||r.error==="login"||r.error==="csrf") {//erreur de version = reload
                                                var delta = time() - startedAt;
                                                if (delta > MIN_TIME_BEFORE_RELOAD) {
                                                    location.reload();    
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        }            
                    } catch(e) {
                        $g.exception(e);
                    }
                    var fnC = complete;
                    complete = null;
                    if (fnC) {
                        fnC();
                    }
                    
                });   
                setTimeout(function() {
                    var fnC = complete;
                    complete = null;
                    if (fnC) {
                        if (fail) {
                            fail();
                        } else {
                            $g.error(PVPGEngine.networkError);
                        }
                        fnC();
                    }
                }, 1000 * 60); 
            });
        }
        essai();
    }
    
    function ready(ready) {
        jobs.exec(function(complete) {
            try {
                ready();
            } catch (e) {
                $g.exception(e);
            }
            complete();
        });
    };    
    
    var srv = {
        call: ajax, 
        ready: ready, 
        isReady: jobs.isReady, 
        afterSuccess: afterSuccess, 
        action: function(url, params) {//Version promesse
            return new Promise(function(accept, reject) {
                ajax(url, params, accept, reject);
            });
        }};    
    $g.server = srv;        
    window.server = srv;
})(PVPGEngine, jQuery);